import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceCard = ({ service, onEdit, onToggleStatus, onDuplicate, onDelete, onViewAnalytics }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('ko-KR')?.format(price);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('ko-KR', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })?.format(date);
  };

  return (
    <div className="rounded-lg bg-card p-6 shadow-card transition-all duration-150 ease-out hover:shadow-lg">
      <div className="mb-4 flex items-start justify-between">
        <div className="flex-1">
          <div className="mb-2 flex items-center space-x-3">
            <h3 className="text-lg font-bold text-foreground">{service?.name}</h3>
            <span
              className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-medium ${
                service?.isActive
                  ? 'bg-success/10 text-success' :'bg-muted text-muted-foreground'
              }`}
            >
              {service?.isActive ? '활성' : '비활성'}
            </span>
          </div>
          <p className="text-sm text-muted-foreground">{service?.description}</p>
        </div>
      </div>
      <div className="mb-4 grid grid-cols-2 gap-4">
        <div>
          <p className="mb-1 text-xs text-muted-foreground">기본 가격</p>
          <p className="text-lg font-bold text-foreground">
            {formatPrice(service?.basePrice)}원
          </p>
        </div>
        <div>
          <p className="mb-1 text-xs text-muted-foreground">프로모션 가격</p>
          <p className="text-lg font-bold text-primary">
            {service?.promotionalPrice ? `${formatPrice(service?.promotionalPrice)}원` : '-'}
          </p>
        </div>
        <div>
          <p className="mb-1 text-xs text-muted-foreground">예상 소요시간</p>
          <p className="text-sm font-medium text-foreground">{service?.turnaroundTime}</p>
        </div>
        <div>
          <p className="mb-1 text-xs text-muted-foreground">최종 수정일</p>
          <p className="text-sm font-medium text-foreground">
            {formatDate(service?.lastModified)}
          </p>
        </div>
      </div>
      {service?.features && service?.features?.length > 0 && (
        <div className="mb-4">
          <p className="mb-2 text-xs font-medium text-muted-foreground">서비스 특징</p>
          <div className="flex flex-wrap gap-2">
            {service?.features?.map((feature, index) => (
              <span
                key={index}
                className="inline-flex items-center rounded-md bg-muted px-2 py-1 text-xs text-foreground"
              >
                <Icon name="Check" size={14} className="mr-1" />
                {feature}
              </span>
            ))}
          </div>
        </div>
      )}
      <div className="flex flex-wrap gap-2">
        <Button
          variant="outline"
          size="sm"
          iconName="Edit"
          iconPosition="left"
          onClick={() => onEdit(service)}
        >
          수정
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Copy"
          iconPosition="left"
          onClick={() => onDuplicate(service)}
        >
          복제
        </Button>
        <Button
          variant={service?.isActive ? 'destructive' : 'success'}
          size="sm"
          iconName={service?.isActive ? 'EyeOff' : 'Eye'}
          iconPosition="left"
          onClick={() => onToggleStatus(service?.id)}
        >
          {service?.isActive ? '비활성화' : '활성화'}
        </Button>
        <Button
          variant="destructive"
          size="sm"
          iconName="Trash2"
          iconPosition="left"
          onClick={() => onDelete?.(service?.id)}
        >
          삭제
        </Button>
        <Button
          variant="ghost"
          size="sm"
          iconName="BarChart3"
          iconPosition="left"
          onClick={() => onViewAnalytics(service)}
        >
          분석
        </Button>
      </div>
    </div>
  );
};

export default ServiceCard;